import Hero from './Hero';
import HeroCards from './HeroCards';

export default function HeroSection() {
  return (
    <>
      <Hero />
      <HeroCards />
    </>
  );
}
